module.exports = {
        srcSet: __webpack_public_path__ + "static/media/HowItWorkSection2-166.afce663d.webp"+" 166w",
        images: [{path: __webpack_public_path__ + "static/media/HowItWorkSection2-166.afce663d.webp",width: 166,height: 166}],
        src: __webpack_public_path__ + "static/media/HowItWorkSection2-166.afce663d.webp",
        toString: function(){return __webpack_public_path__ + "static/media/HowItWorkSection2-166.afce663d.webp"},
        
        width: 166,
        height: 166
      }